import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './index.module.scss';
export const CheckboxField = ({ name, label, checked, onChange }) => {
    return (_jsxs("label", Object.assign({ className: styles.checkboxWrapper }, { children: [_jsx("span", Object.assign({ className: styles.label }, { children: label })), _jsx("input", { type: "checkbox", checked: checked, onChange: e => onChange(name, e.target.checked) }), _jsx("span", { className: styles.customCheckbox })] })));
};
